module.exports = __webpack_public_path__ + "img/icon9.87bfe40.png";